export const SURVEY_CATEGORY_CODE = 232;

export const SURVEY_SOURCE = 'platform';
